import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function FormDetails() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all contacts
  useEffect(() => {
    fetch("https://csgedu.in/csg/get_contacts.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setContacts(data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching contacts:", err);
        setLoading(false);
      });
  }, []);

  // Delete contact handler
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This record will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch("https://csgedu.in/csg/delete_contact.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              // Remove from state instantly
              setContacts(contacts.filter((c) => c.id !== id));

              Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: "The contact record has been removed.",
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: data.message || "Failed to delete record.",
              });
            }
          })
          .catch((err) => {
            console.error("Delete error:", err);
            Swal.fire({
              icon: "error",
              title: "Server Error",
              text: "Could not connect to the server.",
            });
          });
      }
    });
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6 mt-10">
      <h1 className="text-2xl font-bold text-center mb-6 text-blue-700 mt-10">
        Contact Form Submissions
      </h1>

      {loading ? (
        <p className="text-center text-gray-600">Loading...</p>
      ) : contacts.length === 0 ? (
        <p className="text-center text-gray-600">No submissions found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
            <thead className="bg-blue-600 text-white">
              <tr>
                <th className="py-2 px-4 text-left">#</th>
                <th className="py-2 px-4 text-left">Name</th>
                <th className="py-2 px-4 text-left">Email</th>
                <th className="py-2 px-4 text-left">Phone</th>
                <th className="py-2 px-4 text-left">Course</th>
                <th className="py-2 px-4 text-left">Message</th>
                <th className="py-2 px-4 text-left">Date</th>
                <th className="py-2 px-4 text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact, index) => (
                <tr
                  key={contact.id}
                  className="border-t hover:bg-gray-50 transition"
                >
                  <td className="py-2 px-4 text-gray-700">{index + 1}</td>
                  <td className="py-2 px-4 text-gray-700">{contact.name}</td>
                  <td className="py-2 px-4 text-gray-700">{contact.email}</td>
                  <td className="py-2 px-4 text-gray-700">{contact.phone}</td>
                  <td className="py-2 px-4 text-gray-700">{contact.course}</td>
                  <td className="py-2 px-4 text-gray-700">{contact.message}</td>
                  <td className="py-2 px-4 text-gray-700">
                    {new Date(contact.created_at).toLocaleDateString("en-GB")}
                  </td>

                  <td className="py-2 px-4">
                    <button
                      onClick={() => handleDelete(contact.id)}
                      className="bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded text-sm"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
